import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('markets', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`markets/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('markets', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`markets/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`markets/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        levels: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('levels', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        locations: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('locations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        companies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('companies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        societies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('societies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        warehouses: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('storage_warehouses', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        transporters: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('transporters', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

    },
}
